import { render } from "./AppSideMenu.vue?vue&type=template&id=746e33d0&scoped=true"
import script from "./AppSideMenu.vue?vue&type=script&lang=js"
export * from "./AppSideMenu.vue?vue&type=script&lang=js"

import "./AppSideMenu.vue?vue&type=style&index=0&id=746e33d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746e33d0"]])

export default __exports__